import React, { memo, useMemo } from 'react';
import { Controller } from 'react-hook-form';
import MultiSelect, { MultiSelectItem } from '../../molecules/MultiSelect';
import { EvaluationFieldProps } from '../../types/Evaluation';
import { Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  fieldLabel: {
      width: 160,
      fontSize: theme.typography.pxToRem(16),
      color: theme.palette.text.primary,
      fontWeight: 600,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        marginBottom: theme.spacing(0.5),
      },
    },
}), { name: 'MultiSelectInput' }); 

function MultiSelectInput({ name, control, label, selectionMessage = 'Select...', options = [] }: EvaluationFieldProps) {
  const items: MultiSelectItem[] = useMemo(
    () => options.map(opt => ({ value: opt, content: opt })),
    [options],
  );
  const classes = useStyles();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value, onBlur } }) => (
        <>
            <Box className={classes.fieldLabel}>{label}:</Box>
            <MultiSelect
            items={items}
            values={Array.isArray(value) ? value : []}
            labelWhenSelectedNone={selectionMessage}
            onChange={onChange}
            onBlur={onBlur}
            />
        </>
      )}
    />
  );
}

export default memo(MultiSelectInput);
